/**
 * MobileLayout.jsx
 * Layout exclusivo para la aplicación móvil (PWA) sin el sidebar de escritorio
 */
export default function MobileLayout({ children }) {
  return (
    <div className="mobile-app-container" data-testid="mobile-layout">
      {children}
    </div>
  );
}
